/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Api
 * AI Tender Copilot Saudi API
 * OpenAPI spec version: 0.1.0
 */
import * as zod from 'zod';


/**
 * @summary Request a presigned URL for file upload
 */





export const RequestUploadUrlBody = zod.object({
  "name": zod.string().min(1),
  "size": zod.number().min(1),
  "contentType": zod.string().min(1)
})






export const RequestUploadUrlResponse = zod.object({
  "uploadURL": zod.string().url(),
  "objectPath": zod.string(),
  "metadata": zod.object({
  "name": zod.string().min(1),
  "size": zod.number().min(1),
  "contentType": zod.string().min(1)
}).optional()
})


/**
 * @summary Serve a public asset from PUBLIC_OBJECT_SEARCH_PATHS
 */
export const GetPublicObjectParams = zod.object({
  "filePath": zod.coerce.string()
})


/**
 * @summary Serve an object entity from PRIVATE_OBJECT_DIR
 */
export const GetStorageObjectParams = zod.object({
  "objectPath": zod.coerce.string()
})


/**
 * @summary Health check
 */
export const HealthCheckResponse = zod.object({
  "status": zod.string()
})


/**
 * @summary Get current user profile
 */
export const GetMeResponse = zod.object({
  "id": zod.number(),
  "clerkId": zod.string(),
  "email": zod.string(),
  "firstName": zod.string().nullish(),
  "lastName": zod.string().nullish(),
  "role": zod.enum(['admin', 'company_user']),
  "companyId": zod.number().nullish(),
  "isSuspended": zod.boolean().optional(),
  "language": zod.enum(['ar', 'en']).optional(),
  "createdAt": zod.coerce.date()
})


/**
 * @summary Update current user profile
 */
export const UpdateMeBody = zod.object({
  "firstName": zod.string().optional(),
  "lastName": zod.string().optional(),
  "language": zod.enum(['ar', 'en']).optional()
})

export const UpdateMeResponse = zod.object({
  "id": zod.number(),
  "clerkId": zod.string(),
  "email": zod.string(),
  "firstName": zod.string().nullish(),
  "lastName": zod.string().nullish(),
  "role": zod.enum(['admin', 'company_user']),
  "companyId": zod.number().nullish(),
  "isSuspended": zod.boolean().optional(),
  "language": zod.enum(['ar', 'en']).optional(),
  "createdAt": zod.coerce.date()
})


/**
 * @summary Get my company profile
 */
export const GetMyCompanyResponse = zod.object({
  "id": zod.number(),
  "name": zod.string(),
  "sector": zod.string().nullish(),
  "targetRegions": zod.array(zod.string()).optional(),
  "experience": zod.string().nullish(),
  "certifications": zod.array(zod.string()).optional(),
  "minProjectValue": zod.number().nullish(),
  "maxProjectValue": zod.number().nullish(),
  "preferredProjectTypes": zod.array(zod.string()).optional(),
  "bio": zod.string().nullish(),
  "logoUrl": zod.string().nullish(),
  "minBidScore": zod.number().optional().describe('Minimum bid score threshold (0-100). Analyses scoring at or above this value are auto-recommended for bidding.'),
  "analysisUsedThisMonth": zod.number().optional(),
  "createdAt": zod.coerce.date()
})


/**
 * @summary Create or update my company profile
 */
export const UpsertMyCompanyBody = zod.object({
  "name": zod.string(),
  "sector": zod.string().optional(),
  "targetRegions": zod.array(zod.string()).optional(),
  "experience": zod.string().optional(),
  "certifications": zod.array(zod.string()).optional(),
  "minProjectValue": zod.number().optional(),
  "maxProjectValue": zod.number().optional(),
  "preferredProjectTypes": zod.array(zod.string()).optional(),
  "bio": zod.string().optional(),
  "minBidScore": zod.number().optional().describe('Minimum bid score threshold (0-100). Analyses scoring at or above this value are auto-recommended for bidding.')
})

export const UpsertMyCompanyResponse = zod.object({
  "id": zod.number(),
  "name": zod.string(),
  "sector": zod.string().nullish(),
  "targetRegions": zod.array(zod.string()).optional(),
  "experience": zod.string().nullish(),
  "certifications": zod.array(zod.string()).optional(),
  "minProjectValue": zod.number().nullish(),
  "maxProjectValue": zod.number().nullish(),
  "preferredProjectTypes": zod.array(zod.string()).optional(),
  "bio": zod.string().nullish(),
  "logoUrl": zod.string().nullish(),
  "minBidScore": zod.number().optional().describe('Minimum bid score threshold (0-100). Analyses scoring at or above this value are auto-recommended for bidding.'),
  "analysisUsedThisMonth": zod.number().optional(),
  "createdAt": zod.coerce.date()
})


/**
 * @summary List tenders with optional filters
 */
export const ListTendersQueryParams = zod.object({
  "status": zod.coerce.string().optional(),
  "sector": zod.coerce.string().optional(),
  "city": zod.coerce.string().optional(),
  "search": zod.coerce.string().optional(),
  "page": zod.coerce.number().optional(),
  "limit": zod.coerce.number().optional()
})

export const ListTendersResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.number(),
  "title": zod.string(),
  "governmentEntity": zod.string().nullish(),
  "competitionNumber": zod.string().nullish(),
  "sector": zod.string().nullish(),
  "city": zod.string().nullish(),
  "deadline": zod.coerce.date().nullish(),
  "bookletPrice": zod.number().nullish(),
  "tenderUrl": zod.string().nullish(),
  "description": zod.string().nullish(),
  "status": zod.enum(['new', 'analyzing', 'ready', 'bid', 'no_bid', 'submitted', 'lost', 'won']),
  "companyId": zod.number().optional(),
  "hasAnalysis": zod.boolean().optional(),
  "createdAt": zod.coerce.date(),
  "updatedAt": zod.coerce.date().optional()
})),
  "total": zod.number(),
  "page": zod.number(),
  "limit": zod.number()
})


/**
 * @summary Create a new tender
 */
export const CreateTenderBody = zod.object({
  "title": zod.string(),
  "governmentEntity": zod.string().optional(),
  "competitionNumber": zod.string().optional(),
  "sector": zod.string().optional(),
  "city": zod.string().optional(),
  "deadline": zod.coerce.date().optional(),
  "bookletPrice": zod.number().optional(),
  "tenderUrl": zod.string().optional(),
  "description": zod.string().optional(),
  "status": zod.enum(['new', 'analyzing', 'ready', 'bid', 'no_bid', 'submitted', 'lost', 'won']).optional()
})


/**
 * @summary Get a tender by ID
 */
export const GetTenderParams = zod.object({
  "id": zod.coerce.number()
})

export const GetTenderResponse = zod.object({
  "id": zod.number(),
  "title": zod.string(),
  "governmentEntity": zod.string().nullish(),
  "competitionNumber": zod.string().nullish(),
  "sector": zod.string().nullish(),
  "city": zod.string().nullish(),
  "deadline": zod.coerce.date().nullish(),
  "bookletPrice": zod.number().nullish(),
  "tenderUrl": zod.string().nullish(),
  "description": zod.string().nullish(),
  "status": zod.enum(['new', 'analyzing', 'ready', 'bid', 'no_bid', 'submitted', 'lost', 'won']),
  "companyId": zod.number().optional(),
  "hasAnalysis": zod.boolean().optional(),
  "createdAt": zod.coerce.date(),
  "updatedAt": zod.coerce.date().optional()
})


/**
 * @summary Update a tender
 */
export const UpdateTenderParams = zod.object({
  "id": zod.coerce.number()
})

export const UpdateTenderBody = zod.object({
  "title": zod.string().optional(),
  "governmentEntity": zod.string().optional(),
  "competitionNumber": zod.string().optional(),
  "sector": zod.string().optional(),
  "city": zod.string().optional(),
  "deadline": zod.coerce.date().optional(),
  "bookletPrice": zod.number().optional(),
  "tenderUrl": zod.string().optional(),
  "description": zod.string().optional(),
  "status": zod.enum(['new', 'analyzing', 'ready', 'bid', 'no_bid', 'submitted', 'lost', 'won']).optional()
})

export const UpdateTenderResponse = zod.object({
  "id": zod.number(),
  "title": zod.string(),
  "governmentEntity": zod.string().nullish(),
  "competitionNumber": zod.string().nullish(),
  "sector": zod.string().nullish(),
  "city": zod.string().nullish(),
  "deadline": zod.coerce.date().nullish(),
  "bookletPrice": zod.number().nullish(),
  "tenderUrl": zod.string().nullish(),
  "description": zod.string().nullish(),
  "status": zod.enum(['new', 'analyzing', 'ready', 'bid', 'no_bid', 'submitted', 'lost', 'won']),
  "companyId": zod.number().optional(),
  "hasAnalysis": zod.boolean().optional(),
  "createdAt": zod.coerce.date(),
  "updatedAt": zod.coerce.date().optional()
})


/**
 * @summary Delete a tender
 */
export const DeleteTenderParams = zod.object({
  "id": zod.coerce.number()
})


/**
 * @summary List documents for a tender
 */
export const ListTenderDocumentsParams = zod.object({
  "id": zod.coerce.number()
})

export const ListTenderDocumentsResponseItem = zod.object({
  "id": zod.number(),
  "tenderId": zod.number(),
  "fileName": zod.string(),
  "fileSize": zod.number().nullish(),
  "extractedText": zod.string().nullish(),
  "createdAt": zod.coerce.date()
})
export const ListTenderDocumentsResponse = zod.array(ListTenderDocumentsResponseItem)


/**
 * @summary Trigger AI analysis for a tender
 */
export const AnalyzeTenderParams = zod.object({
  "id": zod.coerce.number()
})

export const AnalyzeTenderBody = zod.object({
  "language": zod.enum(['ar', 'en']).optional(),
  "documentId": zod.number().nullish(),
  "manualText": zod.string().nullish()
})

export const AnalyzeTenderResponse = zod.object({
  "id": zod.number(),
  "tenderId": zod.number(),
  "language": zod.string().optional(),
  "executiveSummary": zod.string().nullish(),
  "tenderType": zod.string().nullish(),
  "submissionDeadline": zod.string().nullish(),
  "requiredDocuments": zod.array(zod.string()).optional(),
  "technicalRequirements": zod.array(zod.string()).optional(),
  "financialRequirements": zod.array(zod.string()).optional(),
  "legalRequirements": zod.array(zod.string()).optional(),
  "qualificationRequirements": zod.array(zod.string()).optional(),
  "risks": zod.array(zod.object({
  "title": zod.string(),
  "severity": zod.enum(['low', 'medium', 'high']),
  "description": zod.string().optional()
})).optional(),
  "bidDecision": zod.enum(['bid', 'no_bid', 'needs_review']).optional(),
  "bidScore": zod.number().nullish(),
  "bidReasons": zod.array(zod.string()).optional(),
  "missingInformation": zod.array(zod.string()).optional(),
  "proposalOutline": zod.object({

}).passthrough().nullish(),
  "createdAt": zod.coerce.date()
})


/**
 * @summary Get latest analysis for a tender
 */
export const GetTenderAnalysisParams = zod.object({
  "id": zod.coerce.number()
})

export const GetTenderAnalysisResponse = zod.object({
  "id": zod.number(),
  "tenderId": zod.number(),
  "language": zod.string().optional(),
  "executiveSummary": zod.string().nullish(),
  "tenderType": zod.string().nullish(),
  "submissionDeadline": zod.string().nullish(),
  "requiredDocuments": zod.array(zod.string()).optional(),
  "technicalRequirements": zod.array(zod.string()).optional(),
  "financialRequirements": zod.array(zod.string()).optional(),
  "legalRequirements": zod.array(zod.string()).optional(),
  "qualificationRequirements": zod.array(zod.string()).optional(),
  "risks": zod.array(zod.object({
  "title": zod.string(),
  "severity": zod.enum(['low', 'medium', 'high']),
  "description": zod.string().optional()
})).optional(),
  "bidDecision": zod.enum(['bid', 'no_bid', 'needs_review']).optional(),
  "bidScore": zod.number().nullish(),
  "bidReasons": zod.array(zod.string()).optional(),
  "missingInformation": zod.array(zod.string()).optional(),
  "proposalOutline": zod.object({

}).passthrough().nullish(),
  "createdAt": zod.coerce.date()
})


/**
 * @summary List compliance items for a tender
 */
export const ListComplianceItemsParams = zod.object({
  "id": zod.coerce.number()
})

export const ListComplianceItemsResponseItem = zod.object({
  "id": zod.number(),
  "tenderId": zod.number(),
  "requirement": zod.string(),
  "category": zod.enum(['technical', 'financial', 'legal', 'admin']).optional(),
  "status": zod.enum(['pending', 'ready', 'missing']),
  "owner": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "assignedToUserId": zod.number().nullish(),
  "assignedToName": zod.string().nullish(),
  "createdAt": zod.coerce.date()
})
export const ListComplianceItemsResponse = zod.array(ListComplianceItemsResponseItem)


/**
 * @summary Add a compliance item
 */
export const CreateComplianceItemParams = zod.object({
  "id": zod.coerce.number()
})

export const CreateComplianceItemBody = zod.object({
  "requirement": zod.string(),
  "category": zod.enum(['technical', 'financial', 'legal', 'admin']).optional(),
  "status": zod.enum(['pending', 'ready', 'missing']).optional(),
  "owner": zod.string().optional(),
  "notes": zod.string().optional()
})


/**
 * @summary Update a compliance item
 */
export const UpdateComplianceItemParams = zod.object({
  "itemId": zod.coerce.number()
})

export const UpdateComplianceItemBody = zod.object({
  "requirement": zod.string().optional(),
  "category": zod.enum(['technical', 'financial', 'legal', 'admin']).optional(),
  "status": zod.enum(['pending', 'ready', 'missing']).optional(),
  "owner": zod.string().optional(),
  "notes": zod.string().optional()
})

export const UpdateComplianceItemResponse = zod.object({
  "id": zod.number(),
  "tenderId": zod.number(),
  "requirement": zod.string(),
  "category": zod.enum(['technical', 'financial', 'legal', 'admin']).optional(),
  "status": zod.enum(['pending', 'ready', 'missing']),
  "owner": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "assignedToUserId": zod.number().nullish(),
  "assignedToName": zod.string().nullish(),
  "createdAt": zod.coerce.date()
})


/**
 * @summary Delete a compliance item
 */
export const DeleteComplianceItemParams = zod.object({
  "itemId": zod.coerce.number()
})


/**
 * @summary Export compliance matrix as CSV
 */
export const ExportComplianceCsvParams = zod.object({
  "id": zod.coerce.number()
})


/**
 * @summary Get proposal draft for a tender
 */
export const GetProposalDraftParams = zod.object({
  "id": zod.coerce.number()
})

export const GetProposalDraftResponse = zod.object({
  "id": zod.number(),
  "tenderId": zod.number(),
  "language": zod.string().optional(),
  "content": zod.string().nullish(),
  "introduction": zod.string().nullish(),
  "scopeUnderstanding": zod.string().nullish(),
  "methodology": zod.string().nullish(),
  "team": zod.string().nullish(),
  "timeline": zod.string().nullish(),
  "qualityManagement": zod.string().nullish(),
  "riskManagement": zod.string().nullish(),
  "conclusion": zod.string().nullish(),
  "updatedAt": zod.coerce.date().optional(),
  "createdAt": zod.coerce.date()
})


/**
 * @summary Generate AI proposal draft
 */
export const GenerateProposalDraftParams = zod.object({
  "id": zod.coerce.number()
})

export const GenerateProposalDraftBody = zod.object({
  "language": zod.enum(['ar', 'en']).optional()
})

export const GenerateProposalDraftResponse = zod.object({
  "id": zod.number(),
  "tenderId": zod.number(),
  "language": zod.string().optional(),
  "content": zod.string().nullish(),
  "introduction": zod.string().nullish(),
  "scopeUnderstanding": zod.string().nullish(),
  "methodology": zod.string().nullish(),
  "team": zod.string().nullish(),
  "timeline": zod.string().nullish(),
  "qualityManagement": zod.string().nullish(),
  "riskManagement": zod.string().nullish(),
  "conclusion": zod.string().nullish(),
  "updatedAt": zod.coerce.date().optional(),
  "createdAt": zod.coerce.date()
})


/**
 * @summary Update proposal draft content
 */
export const UpdateProposalDraftParams = zod.object({
  "draftId": zod.coerce.number()
})

export const UpdateProposalDraftBody = zod.object({
  "content": zod.string().optional(),
  "introduction": zod.string().optional(),
  "scopeUnderstanding": zod.string().optional(),
  "methodology": zod.string().optional(),
  "team": zod.string().optional(),
  "timeline": zod.string().optional(),
  "qualityManagement": zod.string().optional(),
  "riskManagement": zod.string().optional(),
  "conclusion": zod.string().optional()
})

export const UpdateProposalDraftResponse = zod.object({
  "id": zod.number(),
  "tenderId": zod.number(),
  "language": zod.string().optional(),
  "content": zod.string().nullish(),
  "introduction": zod.string().nullish(),
  "scopeUnderstanding": zod.string().nullish(),
  "methodology": zod.string().nullish(),
  "team": zod.string().nullish(),
  "timeline": zod.string().nullish(),
  "qualityManagement": zod.string().nullish(),
  "riskManagement": zod.string().nullish(),
  "conclusion": zod.string().nullish(),
  "updatedAt": zod.coerce.date().optional(),
  "createdAt": zod.coerce.date()
})


/**
 * @summary Get HTML report for a tender
 */
export const GetTenderReportParams = zod.object({
  "id": zod.coerce.number()
})

export const GetTenderReportResponse = zod.object({
  "tender": zod.object({
  "id": zod.number(),
  "title": zod.string(),
  "governmentEntity": zod.string().nullish(),
  "competitionNumber": zod.string().nullish(),
  "sector": zod.string().nullish(),
  "city": zod.string().nullish(),
  "deadline": zod.coerce.date().nullish(),
  "bookletPrice": zod.number().nullish(),
  "tenderUrl": zod.string().nullish(),
  "description": zod.string().nullish(),
  "status": zod.enum(['new', 'analyzing', 'ready', 'bid', 'no_bid', 'submitted', 'lost', 'won']),
  "companyId": zod.number().optional(),
  "hasAnalysis": zod.boolean().optional(),
  "createdAt": zod.coerce.date(),
  "updatedAt": zod.coerce.date().optional()
}),
  "analysis": zod.object({
  "id": zod.number(),
  "tenderId": zod.number(),
  "language": zod.string().optional(),
  "executiveSummary": zod.string().nullish(),
  "tenderType": zod.string().nullish(),
  "submissionDeadline": zod.string().nullish(),
  "requiredDocuments": zod.array(zod.string()).optional(),
  "technicalRequirements": zod.array(zod.string()).optional(),
  "financialRequirements": zod.array(zod.string()).optional(),
  "legalRequirements": zod.array(zod.string()).optional(),
  "qualificationRequirements": zod.array(zod.string()).optional(),
  "risks": zod.array(zod.object({
  "title": zod.string(),
  "severity": zod.enum(['low', 'medium', 'high']),
  "description": zod.string().optional()
})).optional(),
  "bidDecision": zod.enum(['bid', 'no_bid', 'needs_review']).optional(),
  "bidScore": zod.number().nullish(),
  "bidReasons": zod.array(zod.string()).optional(),
  "missingInformation": zod.array(zod.string()).optional(),
  "proposalOutline": zod.object({

}).passthrough().nullish(),
  "createdAt": zod.coerce.date()
}).optional(),
  "complianceItems": zod.array(zod.object({
  "id": zod.number(),
  "tenderId": zod.number(),
  "requirement": zod.string(),
  "category": zod.enum(['technical', 'financial', 'legal', 'admin']).optional(),
  "status": zod.enum(['pending', 'ready', 'missing']),
  "owner": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "assignedToUserId": zod.number().nullish(),
  "assignedToName": zod.string().nullish(),
  "createdAt": zod.coerce.date()
})).optional(),
  "proposalDraft": zod.object({
  "id": zod.number(),
  "tenderId": zod.number(),
  "language": zod.string().optional(),
  "content": zod.string().nullish(),
  "introduction": zod.string().nullish(),
  "scopeUnderstanding": zod.string().nullish(),
  "methodology": zod.string().nullish(),
  "team": zod.string().nullish(),
  "timeline": zod.string().nullish(),
  "qualityManagement": zod.string().nullish(),
  "riskManagement": zod.string().nullish(),
  "conclusion": zod.string().nullish(),
  "updatedAt": zod.coerce.date().optional(),
  "createdAt": zod.coerce.date()
}).optional(),
  "company": zod.object({
  "id": zod.number(),
  "name": zod.string(),
  "sector": zod.string().nullish(),
  "targetRegions": zod.array(zod.string()).optional(),
  "experience": zod.string().nullish(),
  "certifications": zod.array(zod.string()).optional(),
  "minProjectValue": zod.number().nullish(),
  "maxProjectValue": zod.number().nullish(),
  "preferredProjectTypes": zod.array(zod.string()).optional(),
  "bio": zod.string().nullish(),
  "logoUrl": zod.string().nullish(),
  "minBidScore": zod.number().optional().describe('Minimum bid score threshold (0-100). Analyses scoring at or above this value are auto-recommended for bidding.'),
  "analysisUsedThisMonth": zod.number().optional(),
  "createdAt": zod.coerce.date()
}).optional()
})


/**
 * @summary Get chat messages for a tender
 */
export const GetChatMessagesParams = zod.object({
  "id": zod.coerce.number()
})

export const GetChatMessagesResponseItem = zod.object({
  "id": zod.number(),
  "tenderId": zod.number(),
  "role": zod.enum(['user', 'assistant']),
  "content": zod.string(),
  "createdAt": zod.coerce.date()
})
export const GetChatMessagesResponse = zod.array(GetChatMessagesResponseItem)


/**
 * @summary Send a message to AI chat
 */
export const SendChatMessageParams = zod.object({
  "id": zod.coerce.number()
})

export const SendChatMessageBody = zod.object({
  "message": zod.string(),
  "language": zod.enum(['ar', 'en']).optional()
})

export const SendChatMessageResponse = zod.object({
  "id": zod.number(),
  "tenderId": zod.number(),
  "role": zod.enum(['user', 'assistant']),
  "content": zod.string(),
  "createdAt": zod.coerce.date()
})


/**
 * @summary List all active plans
 */
export const ListPlansResponseItem = zod.object({
  "id": zod.number(),
  "name": zod.string(),
  "nameAr": zod.string().nullish(),
  "description": zod.string().nullish(),
  "descriptionAr": zod.string().nullish(),
  "priceSar": zod.number(),
  "billingPeriod": zod.enum(['monthly', 'yearly']),
  "analysisLimit": zod.number(),
  "features": zod.array(zod.string()).optional(),
  "featuresAr": zod.array(zod.string()).optional(),
  "isActive": zod.boolean(),
  "stripePriceId": zod.string().nullish(),
  "createdAt": zod.coerce.date()
})
export const ListPlansResponse = zod.array(ListPlansResponseItem)


/**
 * @summary Create a plan (admin only)
 */
export const CreatePlanBody = zod.object({
  "name": zod.string(),
  "nameAr": zod.string().optional(),
  "description": zod.string().optional(),
  "descriptionAr": zod.string().optional(),
  "priceSar": zod.number(),
  "billingPeriod": zod.enum(['monthly', 'yearly']),
  "analysisLimit": zod.number(),
  "features": zod.array(zod.string()).optional(),
  "featuresAr": zod.array(zod.string()).optional(),
  "isActive": zod.boolean().optional(),
  "stripePriceId": zod.string().optional()
})


/**
 * @summary Update a plan (admin only)
 */
export const UpdatePlanParams = zod.object({
  "planId": zod.coerce.number()
})

export const UpdatePlanBody = zod.object({
  "name": zod.string().optional(),
  "nameAr": zod.string().optional(),
  "description": zod.string().optional(),
  "descriptionAr": zod.string().optional(),
  "priceSar": zod.number().optional(),
  "billingPeriod": zod.enum(['monthly', 'yearly']).optional(),
  "analysisLimit": zod.number().optional(),
  "features": zod.array(zod.string()).optional(),
  "featuresAr": zod.array(zod.string()).optional(),
  "isActive": zod.boolean().optional(),
  "stripePriceId": zod.string().optional()
})

export const UpdatePlanResponse = zod.object({
  "id": zod.number(),
  "name": zod.string(),
  "nameAr": zod.string().nullish(),
  "description": zod.string().nullish(),
  "descriptionAr": zod.string().nullish(),
  "priceSar": zod.number(),
  "billingPeriod": zod.enum(['monthly', 'yearly']),
  "analysisLimit": zod.number(),
  "features": zod.array(zod.string()).optional(),
  "featuresAr": zod.array(zod.string()).optional(),
  "isActive": zod.boolean(),
  "stripePriceId": zod.string().nullish(),
  "createdAt": zod.coerce.date()
})


/**
 * @summary Delete a plan (admin only)
 */
export const DeletePlanParams = zod.object({
  "planId": zod.coerce.number()
})


/**
 * @summary Get current subscription
 */
export const GetCurrentSubscriptionResponse = zod.object({
  "id": zod.number(),
  "companyId": zod.number().optional(),
  "planId": zod.number().nullish(),
  "plan": zod.object({
  "id": zod.number(),
  "name": zod.string(),
  "nameAr": zod.string().nullish(),
  "description": zod.string().nullish(),
  "descriptionAr": zod.string().nullish(),
  "priceSar": zod.number(),
  "billingPeriod": zod.enum(['monthly', 'yearly']),
  "analysisLimit": zod.number(),
  "features": zod.array(zod.string()).optional(),
  "featuresAr": zod.array(zod.string()).optional(),
  "isActive": zod.boolean(),
  "stripePriceId": zod.string().nullish(),
  "createdAt": zod.coerce.date()
}).optional(),
  "status": zod.enum(['active', 'cancelled', 'expired', 'trialing']),
  "stripeSubscriptionId": zod.string().nullish(),
  "currentPeriodStart": zod.coerce.date().nullish(),
  "currentPeriodEnd": zod.coerce.date().nullish(),
  "cancelAtPeriodEnd": zod.boolean().optional(),
  "createdAt": zod.coerce.date()
})


/**
 * @summary Create Stripe checkout session
 */
export const CreateCheckoutSessionBody = zod.object({
  "planId": zod.number()
})

export const CreateCheckoutSessionResponse = zod.object({
  "url": zod.string()
})


/**
 * @summary Cancel current subscription
 */
export const CancelSubscriptionResponse = zod.object({
  "id": zod.number(),
  "companyId": zod.number().optional(),
  "planId": zod.number().nullish(),
  "plan": zod.object({
  "id": zod.number(),
  "name": zod.string(),
  "nameAr": zod.string().nullish(),
  "description": zod.string().nullish(),
  "descriptionAr": zod.string().nullish(),
  "priceSar": zod.number(),
  "billingPeriod": zod.enum(['monthly', 'yearly']),
  "analysisLimit": zod.number(),
  "features": zod.array(zod.string()).optional(),
  "featuresAr": zod.array(zod.string()).optional(),
  "isActive": zod.boolean(),
  "stripePriceId": zod.string().nullish(),
  "createdAt": zod.coerce.date()
}).optional(),
  "status": zod.enum(['active', 'cancelled', 'expired', 'trialing']),
  "stripeSubscriptionId": zod.string().nullish(),
  "currentPeriodStart": zod.coerce.date().nullish(),
  "currentPeriodEnd": zod.coerce.date().nullish(),
  "cancelAtPeriodEnd": zod.boolean().optional(),
  "createdAt": zod.coerce.date()
})


/**
 * @summary List invoices for current company
 */
export const ListInvoicesResponseItem = zod.object({
  "id": zod.number(),
  "invoiceNumber": zod.string(),
  "companyId": zod.number().optional(),
  "companyName": zod.string().optional(),
  "planName": zod.string().nullish(),
  "amountSar": zod.number(),
  "vatAmount": zod.number().optional(),
  "totalAmount": zod.number().optional(),
  "status": zod.enum(['paid', 'pending', 'cancelled']),
  "stripeInvoiceId": zod.string().nullish(),
  "pdfUrl": zod.string().nullish(),
  "createdAt": zod.coerce.date()
})
export const ListInvoicesResponse = zod.array(ListInvoicesResponseItem)


/**
 * @summary Download invoice as PDF
 */
export const DownloadInvoiceParams = zod.object({
  "invoiceId": zod.coerce.number()
})


/**
 * @summary Get notification settings
 */
export const GetNotificationSettingsResponse = zod.object({
  "id": zod.number(),
  "companyId": zod.number().optional(),
  "deadlineReminder7Days": zod.boolean().optional(),
  "deadlineReminder1Day": zod.boolean().optional(),
  "analysisComplete": zod.boolean().optional(),
  "subscriptionEvents": zod.boolean().optional()
})


/**
 * @summary Update notification settings
 */
export const UpdateNotificationSettingsBody = zod.object({
  "deadlineReminder7Days": zod.boolean().optional(),
  "deadlineReminder1Day": zod.boolean().optional(),
  "analysisComplete": zod.boolean().optional(),
  "subscriptionEvents": zod.boolean().optional()
})

export const UpdateNotificationSettingsResponse = zod.object({
  "id": zod.number(),
  "companyId": zod.number().optional(),
  "deadlineReminder7Days": zod.boolean().optional(),
  "deadlineReminder1Day": zod.boolean().optional(),
  "analysisComplete": zod.boolean().optional(),
  "subscriptionEvents": zod.boolean().optional()
})


/**
 * @summary List audit log entries
 */
export const ListAuditLogQueryParams = zod.object({
  "tenderId": zod.coerce.number().optional(),
  "page": zod.coerce.number().optional(),
  "limit": zod.coerce.number().optional()
})

export const ListAuditLogResponseItem = zod.object({
  "id": zod.number(),
  "userId": zod.number().nullish(),
  "userEmail": zod.string().nullish(),
  "companyId": zod.number().nullish(),
  "tenderId": zod.number().nullish(),
  "action": zod.string(),
  "entityType": zod.string().optional(),
  "entityId": zod.number().nullish(),
  "before": zod.object({

}).passthrough().nullish(),
  "after": zod.object({

}).passthrough().nullish(),
  "createdAt": zod.coerce.date()
})
export const ListAuditLogResponse = zod.array(ListAuditLogResponseItem)


/**
 * @summary Assign compliance item to a team member
 */
export const AssignComplianceItemParams = zod.object({
  "itemId": zod.coerce.number()
})

export const AssignComplianceItemBody = zod.object({
  "userId": zod.number(),
  "userName": zod.string().optional()
})

export const AssignComplianceItemResponse = zod.object({
  "id": zod.number(),
  "tenderId": zod.number(),
  "requirement": zod.string(),
  "category": zod.enum(['technical', 'financial', 'legal', 'admin']).optional(),
  "status": zod.enum(['pending', 'ready', 'missing']),
  "owner": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "assignedToUserId": zod.number().nullish(),
  "assignedToName": zod.string().nullish(),
  "createdAt": zod.coerce.date()
})


/**
 * @summary List company document library
 */
export const ListDocumentsResponseItem = zod.object({
  "id": zod.number(),
  "companyId": zod.number().optional(),
  "name": zod.string(),
  "documentType": zod.string().nullish(),
  "fileName": zod.string(),
  "fileSize": zod.number().nullish(),
  "createdAt": zod.coerce.date()
})
export const ListDocumentsResponse = zod.array(ListDocumentsResponseItem)


/**
 * @summary Register a document in the library
 */
export const CreateDocumentBody = zod.object({
  "name": zod.string(),
  "documentType": zod.string().optional(),
  "fileName": zod.string(),
  "fileSize": zod.number().optional()
})


/**
 * @summary Delete a document from the library
 */
export const DeleteDocumentParams = zod.object({
  "docId": zod.coerce.number()
})


/**
 * @summary Get company activity feed
 */
export const GetActivityFeedQueryParams = zod.object({
  "limit": zod.coerce.number().optional()
})

export const GetActivityFeedResponseItem = zod.object({
  "id": zod.number(),
  "companyId": zod.number().optional(),
  "userId": zod.number().nullish(),
  "userName": zod.string().nullish(),
  "action": zod.string(),
  "entityType": zod.string().nullish(),
  "entityId": zod.number().nullish(),
  "entityTitle": zod.string().nullish(),
  "createdAt": zod.coerce.date()
})
export const GetActivityFeedResponse = zod.array(GetActivityFeedResponseItem)


/**
 * @summary Get dashboard statistics
 */
export const GetDashboardStatsResponse = zod.object({
  "totalTenders": zod.number(),
  "analyzing": zod.number(),
  "recommendedBid": zod.number(),
  "rejected": zod.number(),
  "analysisUsed": zod.number(),
  "analysisLimit": zod.number(),
  "recentTenders": zod.array(zod.object({
  "id": zod.number(),
  "title": zod.string(),
  "governmentEntity": zod.string().nullish(),
  "competitionNumber": zod.string().nullish(),
  "sector": zod.string().nullish(),
  "city": zod.string().nullish(),
  "deadline": zod.coerce.date().nullish(),
  "bookletPrice": zod.number().nullish(),
  "tenderUrl": zod.string().nullish(),
  "description": zod.string().nullish(),
  "status": zod.enum(['new', 'analyzing', 'ready', 'bid', 'no_bid', 'submitted', 'lost', 'won']),
  "companyId": zod.number().optional(),
  "hasAnalysis": zod.boolean().optional(),
  "createdAt": zod.coerce.date(),
  "updatedAt": zod.coerce.date().optional()
})).optional()
})


/**
 * @summary Get tender counts grouped by status
 */
export const GetTendersByStatusResponseItem = zod.object({
  "status": zod.string(),
  "count": zod.number()
})
export const GetTendersByStatusResponse = zod.array(GetTendersByStatusResponseItem)


/**
 * @summary Get tenders with upcoming deadlines
 */
export const GetUpcomingDeadlinesResponseItem = zod.object({
  "id": zod.number(),
  "title": zod.string(),
  "governmentEntity": zod.string().nullish(),
  "competitionNumber": zod.string().nullish(),
  "sector": zod.string().nullish(),
  "city": zod.string().nullish(),
  "deadline": zod.coerce.date().nullish(),
  "bookletPrice": zod.number().nullish(),
  "tenderUrl": zod.string().nullish(),
  "description": zod.string().nullish(),
  "status": zod.enum(['new', 'analyzing', 'ready', 'bid', 'no_bid', 'submitted', 'lost', 'won']),
  "companyId": zod.number().optional(),
  "hasAnalysis": zod.boolean().optional(),
  "createdAt": zod.coerce.date(),
  "updatedAt": zod.coerce.date().optional()
})
export const GetUpcomingDeadlinesResponse = zod.array(GetUpcomingDeadlinesResponseItem)


/**
 * @summary Admin list all users
 */
export const AdminListUsersResponseItem = zod.object({
  "id": zod.number(),
  "clerkId": zod.string(),
  "email": zod.string(),
  "firstName": zod.string().nullish(),
  "lastName": zod.string().nullish(),
  "role": zod.enum(['admin', 'company_user']),
  "companyId": zod.number().nullish(),
  "isSuspended": zod.boolean().optional(),
  "language": zod.enum(['ar', 'en']).optional(),
  "createdAt": zod.coerce.date()
})
export const AdminListUsersResponse = zod.array(AdminListUsersResponseItem)


/**
 * @summary Admin update user role/status
 */
export const AdminUpdateUserParams = zod.object({
  "userId": zod.coerce.number()
})

export const AdminUpdateUserBody = zod.object({
  "role": zod.enum(['admin', 'company_user']).optional(),
  "isSuspended": zod.boolean().optional()
})

export const AdminUpdateUserResponse = zod.object({
  "id": zod.number(),
  "clerkId": zod.string(),
  "email": zod.string(),
  "firstName": zod.string().nullish(),
  "lastName": zod.string().nullish(),
  "role": zod.enum(['admin', 'company_user']),
  "companyId": zod.number().nullish(),
  "isSuspended": zod.boolean().optional(),
  "language": zod.enum(['ar', 'en']).optional(),
  "createdAt": zod.coerce.date()
})


/**
 * @summary Admin list all companies with usage
 */
export const AdminListCompaniesResponseItem = zod.object({
  "id": zod.number(),
  "name": zod.string(),
  "sector": zod.string().nullish(),
  "analysisUsedThisMonth": zod.number().optional(),
  "totalTenders": zod.number().optional(),
  "planName": zod.string().nullish(),
  "createdAt": zod.coerce.date()
})
export const AdminListCompaniesResponse = zod.array(AdminListCompaniesResponseItem)


/**
 * @summary Get revenue statistics (admin)
 */
export const GetRevenueStatsResponse = zod.object({
  "mrr": zod.number(),
  "activeSubscriptions": zod.number(),
  "totalCompanies": zod.number(),
  "churnThisMonth": zod.number().optional(),
  "revenueThisMonth": zod.number().optional()
})


